import { render, staticRenderFns } from "./SetTimePostPinExpiration.vue?vue&type=template&id=7ede337d&scoped=true"
import script from "./SetTimePostPinExpiration.vue?vue&type=script&lang=js"
export * from "./SetTimePostPinExpiration.vue?vue&type=script&lang=js"
import style0 from "./SetTimePostPinExpiration.vue?vue&type=style&index=0&id=7ede337d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ede337d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ede337d')) {
      api.createRecord('7ede337d', component.options)
    } else {
      api.reload('7ede337d', component.options)
    }
    module.hot.accept("./SetTimePostPinExpiration.vue?vue&type=template&id=7ede337d&scoped=true", function () {
      api.rerender('7ede337d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notifySchool/SetTimePostPinExpiration.vue"
export default component.exports